import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, PLATFORM_ID, signal, computed, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoadingService } from '../loading/loading.service';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EventData } from 'src/app/module/events/models/event.model';

export interface EventSearchResponse {
  data: EventData[];
}

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private http = inject(HttpClient);
  private loadingService = inject(LoadingService);
  private platformId = inject<object>(PLATFORM_ID);


  private readonly _searchText = signal<string>('');
  public readonly searchText = computed(() => this._searchText());

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this._searchText.set(this.getStoredSearchText());
    }
  }

  setSearchText(searchText: string): void {

    this._searchText.set(searchText);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('searchText', searchText);

    }

  }

  private getStoredSearchText(): string {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem('searchText') || '';
    }
    return '';
  }

  clearSearchText(): void {
    this._searchText.set('');
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('searchText');
    }
  }

  getSearchEvents(name: string, showGlobalLoading = true): Observable<EventSearchResponse> {
    if (showGlobalLoading) {
      this.loadingService.show();
    }

    const apiUrl = `${environment.BaseURL}/events/search`;
    const params = new HttpParams().set('name', name);
    const request = this.http.get<EventSearchResponse>(apiUrl, { params });

    return showGlobalLoading
      ? request.pipe(finalize(() => this.loadingService.hide()))
      : request;
  }

}
